import React from 'react'
import LayoutContainer from '../shared/LayoutContainer'
import PageTitle from './PageTitle'
import Menu from './menu/Menu'
import Claim from './Claim'
import UpcomingEvent from './UpcomingEvent'
import HeaderBar from './HeaderBar'

const Header = ({
  siteTitle,
  children,
  hide_details,
  hide_claim,
  nextEventLink,
  nextEventDescription,
}) => (
  <div>
    <LayoutContainer style={{ border: 0 }}>
      <Menu>{children}</Menu>
      <PageTitle>Mt.Olives</PageTitle>
    </LayoutContainer>
    {hide_claim ? (
      <div />
    ) : (
      <div>
        <LayoutContainer style={{ border: 0, background: '#D8D8D8' }}>
          <Claim className="hide-xs" />
        </LayoutContainer>
        <HeaderBar />
      </div>
    )}

    {hide_details ? (
      <div />
    ) : (
      <div>
        <LayoutContainer style={{ border: 0, textAlign: 'center' }}>
          <UpcomingEvent
            link={nextEventLink}
            description={nextEventDescription}
          />
        </LayoutContainer>
      </div>
    )}
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header/Header.js